import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { UsersComponent } from './users/users.component';
import { GroupsComponent } from './groups/groups.component';
import { ManagementLayoutComponent } from './management-layout/management-layout.component';

const routes:
    Routes = [
        {
            path: '',
            component: ManagementLayoutComponent,
            children: [
                {
                    path: 'users',
                    component: UsersComponent,
                },
                {
                    path: 'groups',
                    component: GroupsComponent,
                },
            ]
        },
    ];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class ManagementRoutingModule { }
